export interface PreviousPageDetails {
  url: string;
  name: string;
}

export interface UserProfile {
  skymiles_number: string;
  skymiles_tier: string;
  email?: string;
  encrypted_email: string;
  email_domain: string;
  company_name: string;
  available_miles: string;
  amex_card_type: string;
}

export interface UserAttributes {
  is_logged_in: string;
  login_method?: string;
  login_state?: string;
}

export interface User {
  attributes: UserAttributes;
  profile?: UserProfile;
}

export interface ClickData {
  name: string;
  type: string;
  page_section: string;
  action: string;
}

export interface AnalyticsClick {
  id: string;
  type: string;
  position: string;
  source: string;
  name: string;
  sub_type: string;
  title?: string;
  membership_tier?: string;
  url?: string;
  image?: string;
  subSection?: string;
}

export interface FormData {
  name: string;
  type: string;
  step_name: string;
  step_num: number;
}
export interface ErrorData {
  type: string;
  code: string;
  message: string;
}

export interface PageData {
  info: {
    legacy_page_name: string;
    page_name: string;
    page_url: string;
    previous_page_name: string;
    previous_page_url: string;
    section: string;
    sub_section: string;
    country: string;
    language: string;
    sys_env: string;
    page_load_time: number;
  };
}

export interface AnalyticsData {
  event_detail: string;
  event: string;
  user: User;
  click?: ClickData;
  error?: ErrorData;
  form?: FormData;
  page?: PageData;
}
